/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectNinjaOne200Response
 */
export interface ConnectNinjaOne200Response {
    /**
     * 
     */
    success: boolean;
}

/**
 * Check if a given object implements the ConnectNinjaOne200Response interface.
 */
export function instanceOfConnectNinjaOne200Response(value: object): value is ConnectNinjaOne200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function ConnectNinjaOne200ResponseFromJSON(json: any): ConnectNinjaOne200Response {
    return ConnectNinjaOne200ResponseFromJSONTyped(json, false);
}

export function ConnectNinjaOne200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectNinjaOne200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function ConnectNinjaOne200ResponseToJSON(json: any): ConnectNinjaOne200Response {
    return ConnectNinjaOne200ResponseToJSONTyped(json, false);
}

export function ConnectNinjaOne200ResponseToJSONTyped(value?: ConnectNinjaOne200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

